export default {
  "word": {
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["戻る"])},
    "send": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信"])},
    "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログイン"])},
    "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登録"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名前"])},
    "nick_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ニックネーム"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールアドレス"])},
    "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワード"])},
    "password_current": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現在のパスワード"])},
    "password_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワード確認"])},
    "password_reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードリセット"])},
    "password_new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新しいパスワード"])},
    "terms": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用規約"])},
    "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["必須"])},
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["検索する"])},
    "change": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["変更する"])},
    "contents": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容"])},
    "subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["件名"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本文"])},
    "prefectures": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["都道府県"])},
    "tradingview_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーディングビューユーザー名"])},
    "none": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["指定なし"])},
    "setting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["設定"])},
    "noname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["匿名さん"])}
  },
  "validation": {
    "password_confirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードが一致しません。"])},
    "agree": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意してください。"])}
  },
  "error": {
    "401": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログインして下さい。"])},
    "413": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アップロードサイズが大きすぎます。"])},
    "429": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["リクエスト回数が多すぎます。しばらく時間を空けてからご利用ください。"])},
    "500": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。"])}
  },
  "login": {
    "save_login_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログイン状態を保存する。"])}
  },
  "register": {
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登録を完了するためのメールを送信しました。届いたメールに記載のリンクをクリックして、登録を完了してください。"])}
  },
  "reset_password": {
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードをリセットしました。"])}
  },
  "logout": {
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログアウトしました。"])}
  },
  "forgot_password": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードを忘れたときは？"])},
    "send_link_messeage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードをリセットするためのリンクを送信します。登録したメールアドレスを入力してください。"])},
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードを再設定するためのメールを送信しました。届いたメールに記載のリンクをクリックして、パスワードの再設定画面を開いてください。"])}
  },
  "account": {
    "change_name": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名前変更"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名前を変更しました。"])}
    },
    "change_nick_name": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ニックネーム変更"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ニックネームを変更しました。"])}
    },
    "change_prefectures": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["都道府県変更"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["都道府県を変更しました。"])}
    },
    "change_tradingview_name": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーディングビューユーザー名変更"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーディングビューユーザー名を変更しました。"])}
    },
    "change_email": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールアドレス変更"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールアドレスを変更しました。"])},
      "send_email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["変更を完了するためのメールを送信しました。届いたメールに記載のリンクをクリックして、変更を完了してください。"])}
    },
    "change_password": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワード変更"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードを変更しました。"])}
    }
  },
  "contact": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["お問い合わせ"])},
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ご入力ありがとうございました。お問合せを受け付けいたしました。"])}
  },
  "contact_faq": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["よくあるご質問"])}
  },
  "terms": {
    "labo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["実践トレードラボ"])},
    "shindo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["神藤塾"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ご利用規約"])}
  },
  "seminar": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["セミナー日程"])},
    "button": {
      "before_open": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["申し込み開始前"])},
      "closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["申し込み終了しました"])},
      "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["申し込み"])},
      "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳細確認"])}
    }
  },
  "seminar_details": {
    "title": {
      "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["セミナー申し込み"])},
      "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["セミナー詳細確認"])}
    },
    "apply": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参加登録"])},
      "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参加登録する"])}
    }
  },
  "video_details": {
    "question": {
      "form": {
        "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["質問を入力..."])}
      }
    },
    "complete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ご質問を承りました。"])}
  },
  "not_found": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ページが見つかりませんでした。"])}
  }
}